import { BsSend } from 'react-icons/bs';
import { GoDownload } from 'react-icons/go';
import { useSession } from '@/contexts/LitSessionProvider';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { toSpecialFixed } from '@/lib/misc/utils';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
export default function TransferTx({
  txItem,
  index,
  setModalData
}) {
  const {
    PKP
  } = useSession();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const solanaAddress = PKP?.solanaAddress;
  const ethAddress = PKP?.additionalEthAddress;
  const isOwner = ethAddress === txItem?.to_address || solanaAddress === txItem?.to_address;
  const error = txItem?.status === 'error' || txItem?.result?.decodedResponse?.status !== 'success';
  return <div data-sentry-component="TransferTx" data-sentry-source-file="TransferTx.tsx">
      <div key={index} onClick={() => {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.portfolio.viewReceipt,
        category: CATEGORIES.portfolio
      });
      setModalData({
        isTransfer: true,
        txItem
      });
    }} className='w-full h-[70px] flex items-center hover:bg-genius-blue cursor-pointer transition-colors'>
        <div className='flex w-full justify-between items-center pr-4 pl-4'>
          <div className='flex gap-x-5 items-center relative pl-16'>
            <div className='absolute w-fit top-1 left-0 flex'>
              <div className='w-[35px] h-[35px] flex items-center bg-genius-blue rounded-[8px] justify-center'>
                {txItem?.type === 'deposit' || isOwner ? <GoDownload className='w-[18px] h-[18px] text-genius-cream' /> : <BsSend className='w-[16px] h-[16px] text-genius-cream' />}
              </div>
              <ImageWithFallback src={getNetworkLogo(txItem?.chain_id)} width={14} height={14} alt='network-logo' className='absolute bottom-[-5px] left-6' data-sentry-element="ImageWithFallback" data-sentry-source-file="TransferTx.tsx" />
            </div>
            <div className='flex flex-col gap-y-1'>
              <p className='text-[16px] text-genius-cream capitalize'>
                {isOwner ? txItem?.type === 'deposit' ? txItem?.type?.replace('_', ' ')?.replace('deposit', 'receive').toLowerCase() : txItem?.type?.replace('_', ' ').replace('withdraw', 'Received').toLowerCase() : txItem?.type === 'deposit' ? txItem?.type?.replace('_', ' ')?.replace('deposit', 'receive').toLowerCase() : txItem?.type?.replace('_', ' ').replace('withdraw', 'Send').toLowerCase()}
              </p>
              <div className='flex items-center'>
                <p className='text-genius-cream/50 text-[10px]'>
                  {txItem?.token_metadata?.symbol} - {}
                  {new Date(txItem.created_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric'
                })}
                </p>
              </div>
            </div>
          </div>
          <div className='flex flex-col gap-y-1'>
            <div className='text-right text-genius-cream text-[16px]'>
              {error ? 'Error' : <>
                  <p className='text-[16px]'>
                    {`$${toSpecialFixed(txItem.usd_value, 3).value?.toString().length > 15 ? txItem.usd_value?.toFixed(3) : toSpecialFixed(txItem?.usd_value, 3)?.value}`}
                  </p>
                  <p className='text-genius-cream/50 text-[10px]'>
                    {`${toSpecialFixed(txItem.token_amount_formatted, 3).value} ${txItem.token_metadata?.symbol}`}
                  </p>
                </>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}